module.exports = "/images/playstore.png?470bc18f1d25904077aa6c2bb2fd4ea8";